import { collection, addDoc, query, orderBy, onSnapshot, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase"; // make sure firebase.js is also in /src

export const sendMessage = async (from, to, message) => {
    try {
        await addDoc(collection(db, "chats"), {
            from,
            to,
            message,
            timestamp: serverTimestamp(),
        });
    } catch (err) {
        console.error("Error sending message:", err);
    }
};

export const listenToMessages = (from, to, callback) => {
    const messagesRef = collection(db, "chats");

    const q = query(
        messagesRef,
        orderBy("timestamp")
    );

    return onSnapshot(q, (snapshot) => {
        const msgs = snapshot.docs
            .map((doc) => doc.data())
            .filter(
                (msg) =>
                    (msg.from === from && msg.to === to) ||
                    (msg.from === to && msg.to === from)
            );

        callback(msgs);
    });
};
